﻿<script setup>
    const props = defineProps({
        tab: String
    })

    const $q = useQuasar();
    const tabsCtl = ref({
        tab: '',
        tabs: []
    });

    provide('tabsCtl', tabsCtl);
</script>

<template>
    <div>
        <q-tabs v-model="tabsCtl.tab"
                dense
                class="text-grey"
                active-color="primary"
                indicator-color="primary"
                align="justify"
                narrow-indicator>
            <q-tab v-for="t in tabsCtl.tabs"
                   :name="t.name"
                   :label="t.label"
                   :icon="t.icon"
                   :disable="disabled">
                <q-badge color="red" floating v-if="t.count">{{t.count}}</q-badge>
            </q-tab>
        </q-tabs>

        <q-separator />

        <slot></slot>
    </div>
</template>